module.exports = __webpack_public_path__ + "static/media/TRIAL 1-if-wrong.7bf1d4a5.mp3";